import axios from 'axios';
import { ref } from 'vue'

// const http =  'http://39.108.0.201:54000/api' 
// const http =  'http://www.520mus.top:54000/api' 
 const http =  'http://flower.520mus.top:54009/520musapi'  // 生产环境
// const http =  'http://localhost:8080/520musapi' //开发环境 不行
//const http =  'https://localhost:44392/520muspayapi'//开发环境 不行


export const getTokenvue2login = (userName: any , pwd: any,code: any, uniqueCode: any,autoLogin: any) => {
const params = new URLSearchParams();
params.append('username', userName);
params.append('pwdmima', pwd); 
params.append('uniqueCode', uniqueCode);
params.append('code', code);
params.append('autologin', autoLogin); 
    //return axios.post(http + "/user/loginflower?username="+ userName+"&pwdmima="+pwd+"&code="+uniqueCode+"&code="+code+"&autologin="+autoLogin
    return axios.post(http + "/user/loginflower" ,params
    , {
          headers:{
            // 'Content-Type':"application/json;charset=UTF-8"
            'Content-Type':"application/x-www-form-urlencoded;charset=UTF-8" 
          }
        }
        );   
  } 
export const initialSession = (parms: {}) => {
    return axios.post(http + "/user/InInitialAut", JSON.stringify(parms)
      ,{
          headers:{
            'Content-Type':"application/json;charset=UTF-8"
          }
        }
        );  
  } 